// libs
import Swiper from "../../libs/swiper-6.6.2/swiper-bundle";

import { VideoFrame } from "../_components/_video-frame";
import { CourseHeroText } from "../_components/_course-hero-text";
import { CourseOutcomeSlider } from "../_components/_course-outcome-slider";
import { CourseListSlider } from "../_components/_course-list-slider";
import { CourseListShow } from "../_components/_course-list-show";
import { AdvantagesSlider } from "../_components/_advantages-slider";
import { SliderSeo, InitStickySliderSeo } from "../_components/_slider-seo";
import { CourseOtherSlider } from "../_components/_course-other-slider";

window.$ = jQuery;
window.Swiper = Swiper;

$(document).ready(function () {
	VideoFrame();
	CourseHeroText();
	CourseOutcomeSlider();
	CourseListSlider();
	CourseListShow();
	AdvantagesSlider();
	SliderSeo();
	InitStickySliderSeo();
	CourseOtherSlider();
});

